import { IPublishTerms, IPublishTermsServices } from '../types';
import { mergeId } from './mergeId';
import { mergeService } from './mergeService';

export function mergePublishTerms(prevTerms: IPublishTerms, nextTerms: IPublishTerms): IPublishTerms {
  const selectedServiceId = mergeId(prevTerms.selectedServiceId, nextTerms.selectedServiceId, nextTerms.serviceIds);

  const services = nextTerms.serviceIds.reduce((acc, serviceId) => {
    const prevService = prevTerms.services[serviceId];
    const nextService = nextTerms.services[serviceId];

    if (prevService) {
      acc[serviceId] = mergeService(prevService, nextService);
    } else {
      acc[serviceId] = nextService;
    }

    return acc;
  }, {} as IPublishTermsServices);

  return {
    ...nextTerms,
    selectedServiceId,
    services,
  };
}
